<form *ngIf="form" class="row" [formGroup]="form">
    <mat-form-field>
        <mat-label>
            Numero
        </mat-label>
        <buffered-input formControlName="numero"></buffered-input>
    </mat-form-field>
    <mat-form-field>
        <mat-label>
            Compagnia
        </mat-label>
        <compagnia-picker formControlName="compagnia"></compagnia-picker>
    </mat-form-field>
    <mat-form-field>
        <mat-label>
            Agenzia
        </mat-label>
        <agenzia-picker [defaultSearch]="{compagnia:form?.value?.compagnia}" formControlName="agenzia"></agenzia-picker>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            Ramo
        </mat-label>
        <ramo-picker formControlName="ramo"></ramo-picker>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            Contraente
        </mat-label>
        <contraente-picker type="contraente" formControlName="contraente"></contraente-picker>
    </mat-form-field>

</form>